export default "__VITE_ASSET__BwO6xBmN__"